module.exports = __webpack_public_path__ + "media/images/products/products/j3-7aee968e21944391d59bb4f6e2ad1b2b.jpg";